// ------option------
export const SET_OPTION = 'SET_OPTION'
export const SET_OPTIONLOADING = 'SET_OPTIONLOADING'
// ------option------
// ------form------
export const SET_FORMVALUE  = 'SET_FORMVALUE'
// ------form------
// ------reserveHistory------
export const SET_HISTORYVALUE  = 'SET_HISTORYVALUE'
export const SET_HISTOERYRESULT = 'SET_HISTOERYRESULT'
// ------reserveHistory------
// ------result------
export const SET_RESULTVALUE = 'SET_RESULTVALUE'
// ------result------